import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

/**
 * Available color themes.
 */
export enum ColorMode {
  Light = 'light',
  Dark = 'dark'
}

/**
 * 
 */
export interface IThemeToggleInterface {
  toggleColorMode: () => void;
  mode: ColorMode;
}

/**
 * 
 * @param props 
 * @returns 
 */
const ThemeToggle = (props: IThemeToggleInterface) => {
  return (
    <IconButton sx={{ ml: 1, position: 'fixed', right: 0, bottom: 0 }} onClick={props.toggleColorMode} color="inherit">
      {props.mode === ColorMode.Dark ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  )
}

export default ThemeToggle